import * as types from './types'
import http from '../../utils/http'
// import store from '../index'
import Vue from 'vue'

const vue = new Vue()

// 处理最后一级数组为null
function processTree (data) {
  for (let i = 0; i < data.length; i++) {
    if (data[i].children.length < 1) {
      // children长度小于1, 将children置为null
      data[i].children = null
    } else {
      // 否则继续进入循环
      processTree(data[i].children)
    }
  }
  // 最后处理完的数据
  return data
}

// 处理班级组织下拉选择列表
function processClass (data) {
  for (let i = 0; i < data.length; i++) {
    if (!data[i].sgcClass) {
      data[i].disabled = true
    } else {
      data[i].disabled = false
    }
    if (data[i].children && data[i].children.length) {
      processClass(data[i].children)
    }
  }
  // 最后处理完的数据
  return data
}

const state = {
  /*
  * 人员
  * */
  // 组织结构
  organizationList: [],
  classOrgList: [],
  schoolOrgList: [],
  selectClassList: [],
  selectClassListForQuality: [],
  // 人员列表
  teacherList: {},
  studentList: {},
  studentSelectList: {},
  studentSelectListForExpanded: {},
  graduateList: {},
  userMark: 0,
  isRepetition: false,
  printList:[],
  batchGetList:[],
  selectRole: [],
  // 下拉 标签列表
  selectTag: [],
  exportMark: 0,
  // 教师/班级关系
  RelationsList: {},
  // 教师下拉框
  Teacherselect: [],
  RelationsMark: 0
}

const actions = {
  /*
  * 人员
  * */
  // 组织结构
  [types.GETORGANIZATIONLIST] (context, params) {
    http.fetch('/api/organization/list', params).then(data => {
      context.commit(types.GETORGANIZATIONLIST, {
        ...data,
        mark: params.mark
      })
    })
  },
  // 新增组织结构
  [types.ADDORGANIZATIONLIST] (context, params) {
    http.fetch('/api/organization/add', params).then(data => {
      context.commit(types.ADDORGANIZATIONLIST, data)
    })
  },
  // 编辑组织结构
  [types.EDITORGANIZATIONLIST] (context, params) {
    http.fetch('/api/organization/update', params).then(data => {
      context.commit(types.EDITORGANIZATIONLIST, data)
    })
  },
  // 移除组织
  [types.DELETEORGANIZATION] (context, params) {
    http.fetch('/api/organization/delete', params).then(data => {
      context.commit(types.DELETEORGANIZATION, data)
    })
  },
  /*
  * 教师
  * */
  // 教师列表
  [types.GETTEACHER] (context, params) {
    http.fetch('/api/userTeacher/getUserTeacher', params).then(data => {
      context.commit(types.GETTEACHER, data)
    })
  },
  // 导入教师
  [types.EXPORTEACHER] (context, params) {
    http.fetch('/api/userTeacher/importTeacher', params).then(data => {
      context.commit(types.EXPORTEACHER, data)
    })
  },
  // 新增教师
  [types.ADDTEACHER] (context, params) {
    http.fetch('/api/userTeacher/add', params).then(data => {
      context.commit(types.ADDTEACHER, data)
    })
  },
  // 编辑教师
  [types.UPDATETEACHER] (context, params) {
    http.fetch('/api/userTeacher/update', params).then(data => {
      context.commit(types.UPDATETEACHER, data)
    })
  },
  // 移除教师
  [types.DELETETEACHER] (context, params) {
    http.fetch('/api/userTeacher/delete', params).then(data => {
      context.commit(types.DELETETEACHER, data)
    })
  },
  /*
* 学生
* */
  // 学生列表
  [types.GETSTUDENT] (context, params) {
    http.fetch('/api/userStudent/page', params).then(data => {
      context.commit(types.GETSTUDENT, data)
    })
  },
  // 导出学生
  [types.EXPORTSTUDENT] (context, params) {
    http.fetch('/api/userStudent/importStudent', params).then(data => {
      context.commit(types.EXPORTSTUDENT, data)
    })
  },
  // 新增学生
  [types.ADDSTUDENT] (context, params) {
    http.fetch('/api/userStudent/add', params).then(data => {
      context.commit(types.ADDSTUDENT, data)
    })
  },
  // 编辑学生
  [types.UPDATESTUDENT] (context, params) {
    http.fetch('/api/userStudent/update', params).then(data => {
      context.commit(types.UPDATESTUDENT, data)
    })
  },
  // 移除学生
  [types.DELETESTUDENT] (context, params) {
    http.fetch('/api/userStudent/delete', params).then(data => {
      context.commit(types.DELETESTUDENT, data)
    })
  },
  // 升年级
  [types.RISEGRADE] (context, params) {
    http.fetch('/api/userStudent/riseGrade', params).then(data => {
      context.commit(types.RISEGRADE, data)
    })
  },
  // 毕业
  [types.ADDGRADE] (context, params) {
    http.fetch('/api/userStudent/addGraduationStudent', params).then(data => {
      context.commit(types.ADDGRADE, data)
    })
  },
  // 查询学生下拉框数据（根据学校/年级/班级）
  [types.GETSTUSELECTLIST] (context, params) {
    http.fetch('/api/userStudent/list', params).then(data => {
      context.commit(types.GETSTUSELECTLIST, data)
    })
  },
  // 职务设置，人员下拉框（走班课程）
  [types.GETSTUSELECTLISTFOREXPEND] (context, params) {
    http.fetch('/api/userStudent/listForExpanded', params).then(data => {
      context.commit(types.GETSTUSELECTLISTFOREXPEND, data)
    })
  },
  /*
  * 毕业生
  * */
  // 列表
  [types.GETSGRADUATE] (context, params) {
    http.fetch('/api/Graduate/getGraduate', params).then(data => {
      context.commit(types.GETSGRADUATE, data)
    })
  },
  // 编号查重
  [types.CHECKUSER] (context, params) {
    http.fetch('/api/user/check', params).then(data => {
      context.commit(types.CHECKUSER, data)
    })
  },
  [types.PRINT] (context, params) {
    http.fetch('/api/task/print', params).then(data => {
      context.commit(types.PRINT, data)
    })
  },
  [types.batchGetTaskDetails] (context, params) {
    http.fetch('/api/task/batchGetTaskDetails', params).then(data => {
      context.commit(types.batchGetTaskDetails, data)
    })
  },
  
  /*
  * 角色管理
  * */
  // 列表
  // [types.GETROLE] (context, params) {
  //   http.fetch('/api/role/page', params).then(data => {
  //     context.commit(types.GETROLE, data)
  //   })
  // },
  // // 下拉
  [types.GETSELECTROLE] (context, params) {
    http.fetch('/api/role/selectRole', params).then(data => {
      context.commit(types.GETSELECTROLE, data)
    })
  },
   [types.printAccept] (context, params) {
    http.fetch('/api/task/printAccept', params).then(data => {
      context.commit(types.printAccept, data)
    })
  },
  
  // 数据字典 下拉 标签列表
  [types.GETSELECTTAGS] (context, params) {
    http.fetch('/api/dict/getPageChild', params).then(data => {
      context.commit(types.GETSELECTTAGS, data)
    })
  },
  // 教师/班级关系列表
  [types.GETCLASSTEACHERSET] (context, params) {
    http.fetch('/api/classTeacherSet/getClassTeacherSet', params).then(data => {
      context.commit(types.GETCLASSTEACHERSET, data)
    })
  },
  // 教师下拉框
  [types.GETTEACHERSELECT] (context, params) {
    http.fetch('/api/classTeacherSet/getTeacher', params).then(data => {
      context.commit(types.GETTEACHERSELECT, data)
    })
  },
  // 修改教师班级关系
  [types.UPDATECLASSTEACHERSET] (context, params) {
    http.fetch('/api/classTeacherSet/updateClassTeacherSet', params).then(data => {
      context.commit(types.UPDATECLASSTEACHERSET, data)
    })
  }
}

const mutations = {
  /*
  * 人员
  * */
  // 组织结构
  [types.GETORGANIZATIONLIST] (state, data) {
    if (data.obj) {
      data.obj.data = processTree(data.obj.data)
      if (data.mark === 2) {
        state.organizationList = data.obj
      } else if (data.mark === 3) {
        state.classOrgList = data.obj
        state.selectClassList = processClass(data.obj.data)
        // state.selectClassList = data.obj.data
      } else if (data.mark === 4) {
        state.schoolOrgList = data.obj
      }
    }
  },
  // 新增组织结构
  [types.ADDORGANIZATIONLIST] (state, data) {
    if (data.code === 200) {
      state.userMark = 1
      vue.$message({
        showClose: true,
        message: '添加成功',
        type: 'success'
      })
    }
  },
  // 编辑组织结构
  [types.EDITORGANIZATIONLIST] (state, data) {
    if (data.code === 200) {
      state.userMark = 1
      vue.$message({
        showClose: true,
        message: '修改成功',
        type: 'success'
      })
    }
  },
  // 移除组织
  [types.DELETEORGANIZATION] (state, data) {
    if (data.code === 200) {
      state.userMark = 1
      vue.$message({
        showClose: true,
        message: '移除成功',
        type: 'success'
      })
    }
  },
  /*
  * 教师
  * */
  // 教师列表
  [types.GETTEACHER] (state, data) {
    state.teacherList = data
  },
  // 导出教师
  [types.EXPORTEACHER] (state, data) {
    state.exportMark = 1
    if (data.obj) {
      vue.$message({
        showClose: true,
        message: data.message,
        type: 'error'
      })
      location.href = data.obj
    } else {
      vue.$message({
        showClose: true,
        message: '导入成功',
        type: 'success'
      })
    }
  },
  // 新增教师
  [types.ADDTEACHER] (state, data) {
    if (data.code === 200) {
      state.userMark = 1
      vue.$message({
        showClose: true,
        message: '新增成功',
        type: 'success'
      })
    }
  },
  // 编辑教师
  [types.UPDATETEACHER] (state, data) {
    if (data.code === 200) {
      state.userMark = 1
      vue.$message({
        showClose: true,
        message: '修改成功',
        type: 'success'
      })
    }
  },
  // 移除教师
  [types.DELETETEACHER] (state, data) {
    if (data.code === 200) {
      state.userMark = 1
      vue.$message({
        showClose: true,
        message: '移除成功',
        type: 'success'
      })
    }
  },
  /*
  * 学生
  * */
  // 学生列表
  [types.GETSTUDENT] (state, data) {
    state.studentList = data
    console.log(state.studentList, 'StudentList.vue')
  },
  // 导出学生
  [types.EXPORTSTUDENT] (state, data) {
    state.exportMark = 1
    if (data.obj) {
      vue.$message({
        showClose: true,
        message: data.message,
        type: 'error'
      })
      location.href = data.obj
    } else {
      vue.$message({
        showClose: true,
        message: '导入成功',
        type: 'success'
      })
    }
  },
  // 新增学生
  [types.ADDSTUDENT] (state, data) {
    if (data.code === 200) {
      state.userMark = 1
      vue.$message({
        showClose: true,
        message: '新增成功',
        type: 'success'
      })
    }
  },
  // 编辑学生
  [types.UPDATESTUDENT] (state, data) {
    if (data.code === 200) {
      state.userMark = 1
      vue.$message({
        showClose: true,
        message: '修改成功',
        type: 'success'
      })
    }
  },
  // 移除学生
  [types.DELETESTUDENT] (state, data) {
    if (data.code === 200) {
      state.userMark = 1
      vue.$message({
        showClose: true,
        message: '移除成功',
        type: 'success'
      })
    }
  },
  // 升年级
  [types.RISEGRADE] (state, data) {
    if (data.code === 200) {
      state.userMark = 1
      vue.$message({
        showClose: true,
        message: '升年级成功',
        type: 'success'
      })
    }
  },
  // 毕业
  [types.ADDGRADE] (state, data) {
    if (data.code === 200) {
      state.userMark = 1
      vue.$message({
        showClose: true,
        message: '毕业成功',
        type: 'success'
      })
    }
  },
  // 查询学生下拉框数据（根据学校/年级/班级）
  [types.GETSTUSELECTLIST] (state, data) {
    state.studentSelectList = data
    console.log(data, 'GETSTUSELECTLIST')
  },
  // 职务设置，人员下拉框（走班课程）
  [types.GETSTUSELECTLISTFOREXPEND] (state, data) {
    state.studentSelectListForExpanded = data
    console.log(data, 'GETSTUSELECTLISTFOREXPEND')
  },
  /*
  * 毕业生
  * */
  // 列表
  [types.GETSGRADUATE] (state, data) {
    state.graduateList = data
  },
  // 员工编号查重
  [types.CHECKUSER] (state, data) {
    if (data.obj.status === 1) {
      // state.isCHECKUSERCheck = true
      state.isRepetition = false
      vue.$message({
        showClose: true,
        message: '没有重复编号',
        type: 'success'
      })
    } else {
      state.isRepetition = true
    }
  },
  [types.PRINT] (state, data) {
    state.printList = data
  },
  [types.batchGetTaskDetails] (state, data) {
    state.batchGetList = data.obj
  },
  
  /*
  * 角色管理
  * */
  [types.GETSELECTROLE] (state, data) {
    state.selectRole = data
  },
  [types.printAccept] (state, data) {
    // state.printAccept = data
  },
  // 下拉 标签列表
  [types.GETSELECTTAGS] (state, data) {
    state.selectTag = data
  },
  // 教师/班级关系列表
  [types.GETCLASSTEACHERSET] (state, data) {
    state.RelationsList = data
    console.log(state.RelationsList, 'state.RelationsList')
  },
  // 教师下拉框
  [types.GETTEACHERSELECT] (state, data) {
    state.Teacherselect = data.obj
    console.log(state.Teacherselect, 'state.Teacherselect')
  },
  // 修改教师班级关系
  [types.UPDATECLASSTEACHERSET] (state, data) {
    if (data.code === 200) {
      state.RelationsMark = 1
      vue.$message({
        showClose: true,
        message: '修改成功',
        type: 'success'
      })
    }
  }
}

export default {
  state, actions, mutations
}



// WEBPACK FOOTER //
// ./src/store/userData/index.js